var map = {
	"./de/general8/slide1.svg": 73757,
	"./en/general8/slide1.svg": 388889,
	"./es/general8/slide1.svg": 444368,
	"./fr/general8/slide1.svg": 156952,
	"./nl/general8/slide1.svg": 62682,
	"./pt/general8/slide1.svg": 26612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255427;